import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

// WhatsApp number lives here. Wrapped in a tiny pop-tooltip on first visit
// so visitors discover the channel rather than miss the icon.
const WHATSAPP_NUMBER = '447577368808'; // E.164 without "+", as required by wa.me
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi Dr. Nair, I'd like to connect with you."
)}`;

const WhatsAppButton = () => {
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    // Show the tooltip once per session, ~2.5s after page load
    if (sessionStorage.getItem('srn_wa_tip_seen')) return;
    const t = setTimeout(() => {
      setShowTip(true);
      sessionStorage.setItem('srn_wa_tip_seen', '1');
    }, 2500);
    return () => clearTimeout(t);
  }, []);

  const dismissTip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowTip(false);
  };

  return (
    <div
      className="fixed left-6 bottom-6 z-40 flex items-end gap-3"
      data-testid="whatsapp-floating"
    >
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="group relative w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-10px_rgba(37,211,102,0.6)] hover:shadow-[0_18px_40px_-10px_rgba(37,211,102,0.7)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center"
        data-testid="whatsapp-btn"
      >
        {/* Pulsing ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="relative w-7 h-7 fill-white"
        >
          <path d="M19.11 17.21c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.6.13-.18.27-.69.88-.84 1.06-.16.18-.31.2-.58.07-.27-.13-1.13-.42-2.15-1.33-.79-.71-1.33-1.58-1.49-1.85-.16-.27-.02-.42.12-.55.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.44-.82-1.98-.22-.52-.44-.45-.6-.46-.16-.01-.34-.01-.52-.01-.18 0-.47.07-.71.34-.25.27-.94.92-.94 2.24 0 1.32.96 2.6 1.1 2.78.13.18 1.88 2.88 4.56 4.04.64.28 1.13.44 1.52.56.64.2 1.22.17 1.68.1.51-.08 1.6-.65 1.82-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.31zM12.04 2C6.51 2 2.02 6.49 2.02 12.02c0 1.77.46 3.49 1.34 5L2 22l5.1-1.33a9.98 9.98 0 0 0 4.93 1.27h.01c5.52 0 10.01-4.49 10.01-10.02 0-2.68-1.04-5.2-2.93-7.09A9.96 9.96 0 0 0 12.04 2zm0 18.16c-1.55 0-3.06-.42-4.39-1.2l-.31-.18-3.03.79.81-2.95-.2-.32a8.13 8.13 0 0 1-1.25-4.36c0-4.5 3.67-8.16 8.18-8.16 2.18 0 4.23.85 5.78 2.39a8.13 8.13 0 0 1 2.39 5.77c0 4.5-3.67 8.22-8.18 8.22z" />
        </svg>
      </a>

      {showTip && (
        <button
          onClick={dismissTip}
          className="relative flex items-start gap-2 px-4 py-2.5 bg-[#fffdf8] border border-[#e6dfd0] rounded-2xl shadow-[0_12px_30px_-10px_rgba(21,40,70,0.2)] text-left animate-in slide-in-from-left-2 fade-in"
          data-testid="whatsapp-tooltip"
          aria-label="Dismiss WhatsApp tooltip"
        >
          <MessageCircle size={16} strokeWidth={2.5} className="text-[#25D366] mt-0.5 shrink-0" />
          <span className="text-sm text-[#152846] font-medium pr-4">
            Chat with Dr. Nair on WhatsApp
          </span>
          <X size={14} strokeWidth={2.5} className="absolute top-2 right-2 text-[#aab2bf]" />
          {/* Speech-bubble pointer */}
          <span className="absolute -left-1.5 bottom-4 w-3 h-3 bg-[#fffdf8] border-l border-b border-[#e6dfd0] rotate-45" />
        </button>
      )}
    </div>
  );
};

export default WhatsAppButton;
